module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-144x144-700ce70fa042c1f86beb302a6c55b920.png";